import { render, staticRenderFns } from "./registrationProgramView.vue?vue&type=template&id=636301b6&scoped=true&"
import script from "./registrationProgramView.vue?vue&type=script&lang=js&"
export * from "./registrationProgramView.vue?vue&type=script&lang=js&"
import style0 from "./registrationProgramView.vue?vue&type=style&index=0&id=636301b6&prod&lang=scss&scoped=true&"
import style1 from "./registrationProgramView.vue?vue&type=style&index=1&id=636301b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636301b6",
  null
  
)

export default component.exports